export default {
  extensionFeedbacks: [],
  extensionFeedback: undefined,
};
